import { ref } from 'vue'
import { defineStore } from 'pinia'
import { apiClient } from '@/api/client'

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
}

export const useChatbotStore = defineStore('chatbot', () => {
  const isOpen = ref(false)
  const messages = ref<ChatMessage[]>([])
  const isLoading = ref(false)

  function toggleOpen() {
    isOpen.value = !isOpen.value
  }

  async function send(text: string) {
    if (!text.trim() || isLoading.value) return
    messages.value.push({ role: 'user', content: text })
    isLoading.value = true
    try {
      const res = await apiClient.post<{ risposta: string }>('/api/v2/chatbot/ask', { messaggio: text })
      messages.value.push({ role: 'assistant', content: res.data.risposta })
    } catch {
      messages.value.push({ role: 'assistant', content: 'Si è verificato un errore. Riprova.' })
    } finally {
      isLoading.value = false
    }
  }

  function reset() {
    messages.value = []
  }

  return { isOpen, messages, isLoading, toggleOpen, send, reset }
})
